import * as React from 'react';

const Loader = ({ fullwidth = false }) => (
  <span
    className={`loader button is-loading is-white ${
      fullwidth ? 'is-fullwidth' : ''
    }`}
  />
);
export default Loader;
